/* eslint-disable no-param-reassign */
/* eslint-disable import/no-cycle */
/* eslint-disable func-names */
import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import { ALERTAS_ROUTE } from "../../../constants";
import api from "../../../services/api";
import DateHelper from "../../../utils/dateHelper";
import { INITIAL_STATE_VALUES, Types } from "../../ducks/alertas/analise";
import executeAction from "../comum/executeAction";

function converterDatasExibir(monitoramento) {
	for (let i = 0; i < monitoramento.registroMonitoramento.length; i++) {
		monitoramento.registroMonitoramento[
			i
		].horaAnalise = DateHelper.convertStringDate(
			monitoramento.registroMonitoramento[i].horaAnalise,
			"HH:mm",
			"HH:mm:ss"
		);
	}
}

function* asyncMonitoramentoBuscarPorAlertaId(action) {
	yield executeAction(function*() {
		const { alertaId, callback } = action;

		const { data } = yield call(
			api.get,
			ALERTAS_ROUTE.FIND_BY_ID.replace("{alertaId}", alertaId)
		);

		let { monitoramento } = data;

		monitoramento = monitoramento || INITIAL_STATE_VALUES.monitoramento;

		monitoramento.alertaId = data.id;

		monitoramento.alertaStatus = data.statusAtualAlerta;

		if (monitoramento.registroMonitoramento) {
			converterDatasExibir(monitoramento);
		}

		yield put({
			type: Types.ANALISE_BUSCAR_POR_ALERTA_ID_REDUCER,
			analise: monitoramento,
			data
		});

		if (callback) callback(false);
	}, Types.ANALISE_BUSCAR_POR_ALERTA_ID);
}

function* takeMonitoramentoBuscarPorAlertaId() {
	yield takeLatest(
		Types.ANALISE_BUSCAR_POR_ALERTA_ID,
		asyncMonitoramentoBuscarPorAlertaId
	);
}

export default function* root() {
	yield all([fork(takeMonitoramentoBuscarPorAlertaId)]);
}
